import React, { useEffect, useState } from "react";
import "./style.css";
import {
  Container,
  ContainerTable,
  Menus,
  Table,
  Theader,
  Trbody,
  Td,
  Th,
  Title,
  Buttons,
  Colletion,
  Grup,
  Tbody,
  EditButton,
  DeleteButton,
  DesativarButton,
  AtivarButton,
  UploadPhto,
  TdUpload,
  PreviewImage,
  ThRm,
} from "./style";
import Button from "../../Components/Button";
import UserDefault from "../../assets/images/user.png";
import { useNavigate } from "react-router-dom";
import Pesquisar from "../../Components/Pesquisar";
import api from "../../Services/api";
import EditAluno from "../../Components/modals/EditAluno";
import { Alert } from "../../utils/Alert";
import ViewPicture from "../../Components/modals/ViewPictiure";
import * as XLSX from "xlsx";
import { format } from "date-fns";
import { Database } from "lucide-react";
import Url_Image from "../../assets/URL'S/Url_Image";
import Loading from "../../utils/Loading/Points/index.jsx";

export default function VisualizarAlunos() {
  const Navigate = useNavigate();
  const [Show, setShow] = useState(false);
  const [viewPicture, setViewPicture] = useState(false);
  const [imgAluno, setImgAluno] = useState("");
  const [alunos, setAlunos] = useState([]);
  const [alunosBk, setAlunosBk] = useState([]);
  const [exibirInativos, setExibirInativos] = useState(false);
  const [editAluno, setEditAluno] = useState([]);
  const [TrocaTextoInativos, setTrocaTextoInativos] = useState("");
  const [searchRm, setSearchRm] = useState("");
  const [searchNome, setSearchNome] = useState("");
  const [searchDataNascimento, setSearchDataNascimento] = useState("");
  const [searchDataInicio, setSearchDataInicio] = useState("");
  const [searchDataFim, setSearchDataFim] = useState("");
  const [searchCurso, setSearchCurso] = useState("");
  const [searchConvenio, setSearchConvenio] = useState("");
  const [mostrarTodos, setMostrarTodos] = useState(300);
  const [reload, setReload] = useState(false);
  const [loadingFotosPorRM, setLoadingFotosPorRM] = useState({});
  const [fotosAlunos, setFotosAlunos] = useState({});
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const limite = 0.1; // 10%
  // const limite = 200; // 10%

  async function getallalunos() {
    try {
      const { data } = await api.get("/aluno/listar", {
        headers: {
          "x-page": page,
          "x-limite": 10000, //limite,
        },
      });
      if (data?.mensagem?.includes("Nenhum aluno encontrado")) {
        setAlunos([]);
        setAlunosBk([]);
      } else {
        const alunos = data.alunos;
        setAlunos(alunos);
        setAlunosBk(alunos);
        setMostrarTodos(alunos.length * limite);
        // setTotalPages(data.totalPage || 0);
        // setTotalItems(data.totalAlunos || 0);
        // // Se a página atual é maior que o total de páginas, voltar para página 1
        // if (page > data.totalPage && data.totalPage > 0) {
        //   setPage(1);
        // }
      }
    } catch (err) {
      console.log(err);
      // Alert({tipo:"Erro2", mensagem: "Erro ao carregar os dados."});
    } finally {
      setReload(false);
    }
  }

  const normalizeString = (str) => {
    if (str === undefined || str === null) {
      return "";
    }
    return str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  };

  const filteredAlunos = alunos
    .filter((aluno) => {
      const searchRMNormalized = normalizeString(searchRm);
      const searchNomeNormalized = normalizeString(searchNome);
      const searchCursoNormalized = normalizeString(searchCurso);
      const searchConvenioNormalized = normalizeString(searchConvenio);
      const searchDataNascimentoNormalized = normalizeString(searchDataNascimento);
      const searchDataInicioNormalized = normalizeString(searchDataInicio);
      const searchDataFimNormalized = normalizeString(searchDataFim);

      const alunoRM = normalizeString(aluno.rm?.toString() || "");
      const alunoNome = normalizeString(aluno.nome_aluno || "");
      const alunoCurso = normalizeString(aluno.nome_curso || "");
      const alunoConvenio = normalizeString(aluno.convenio || "");
      const alunoDataNascimento = normalizeString(
        aluno.dt_nascimento ? format(new Date(aluno.dt_nascimento), "dd/MM/yyyy") : ""
      );
      const alunoDataInicio = normalizeString(aluno.dt_inicio ? format(new Date(aluno.dt_inicio), "dd/MM/yyyy") : "");
      const alunoDataFim = normalizeString(aluno.dt_termino ? format(new Date(aluno.dt_termino), "dd/MM/yyyy") : "");

      return (
        alunoRM.includes(searchRMNormalized) &&
        alunoNome.includes(searchNomeNormalized) &&
        alunoCurso.includes(searchCursoNormalized) &&
        alunoConvenio.includes(searchConvenioNormalized) &&
        alunoDataNascimento.includes(searchDataNascimentoNormalized) &&
        alunoDataInicio.includes(searchDataInicioNormalized) &&
        alunoDataFim.includes(searchDataFimNormalized)
      );
    })
    .slice(0, mostrarTodos);

  useEffect(() => {
    getallalunos();
  }, [reload]); // , page

  useEffect(() => {
    if (filteredAlunos?.length > 0) carregarFotos();
  }, [reload, filteredAlunos?.length]); // , page

  async function carregarFotos() {
    const novasFotos = { ...fotosAlunos };
    const novosLoadings = {};

    await Promise.all(
      filteredAlunos.map(async (aluno) => {
        const rm = aluno.rm;
        novosLoadings[rm] = true;
        setLoadingFotosPorRM((prev) => ({ ...prev, ...novosLoadings }));

        const imagem = await Url_Image(rm, true);
        novasFotos[rm] = imagem;

        setFotosAlunos((prev) => ({ ...prev, [rm]: imagem }));
        setLoadingFotosPorRM((prev) => ({ ...prev, [rm]: false }));
      })
    );
  }

  useEffect(() => {
    if (exibirInativos) {
      setTrocaTextoInativos("Mostrar Todos");
      setAlunos(alunosBk.filter((a) => a.ativo != 1));
      setMostrarTodos(alunosBk.filter((a) => a.ativo != 1).length);
    } else {
      setTrocaTextoInativos("Mostrar Inativos");
      setAlunos(alunosBk.filter((a) => a.ativo != "qualquer coisa"));
    }
  }, [exibirInativos]);

  // useEffect(() => {
  //   if (searchRm.length > 1 || searchNome.length > 1 || searchDataNascimento.length > 1 || searchDataInicio.length > 1 ||
  //     searchDataFim.length > 1 || searchCurso.length > 1 || searchConvenio.length > 1) {
  //     setMostrarTodos(alunos.length)
  //   } else {
  //     setMostrarTodos(alunos.length * limite)
  //   }
  // }, [searchRm, searchNome, searchDataNascimento, searchDataInicio, searchDataFim, searchCurso, searchConvenio]);

  async function takePhoto(img) {
    try {
      setImgAluno(img);
      setTimeout(() => {
        setViewPicture(true);
      }, 600);
    } catch (err) {
      console.log(err);
    }
  }

  const formatarDados = (dados) => {
    return dados.map((aluno) => ({
      RM: aluno.rm,
      NOME: aluno.nome_aluno,
      EMAIL: aluno.email,
      "DATA NASCIMENTO": format(new Date(aluno.dt_nascimento), "dd/MM/yyyy"),
      CURSO: aluno.nome_curso,
      CONVÊNIO: aluno.convenio,
      "DATA DE INÍCIO": format(new Date(aluno.dt_inicio), "dd/MM/yyyy"),
      "DATA DE TÉRMINO": format(new Date(aluno.dt_termino), "dd/MM/yyyy"),
    }));
  };

  const handleDownloadXLSX = () => {
    if (filteredAlunos) {
      const dadosFormatados = formatarDados(filteredAlunos);
      const ws = XLSX.utils.json_to_sheet(dadosFormatados);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
      XLSX.writeFile(wb, "alunos.xlsx");
    } else {
      console.log("algo deu errado");
    }
  };

  async function desativarAluno(rm, id_aluno, ativo) {
    try {
      const { isConfirmed } = await Alert({
        tipo: "Alert",
        mensagem: `Deseja ${ativo ? "desativar" : "ativar"} o aluno ${rm}`,
      });
      if (isConfirmed) {
        await api.put(`/aluno/atualizar-status?id_aluno=${id_aluno}&rm=${rm}`);
        setReload(true);
      }
    } catch (err) {
      console.log(err);
      Alert({ tipo: "Erro2", mensagem: "Ocorreu um erro ao desativar aluno" });
    }
  }

  async function deletarAluno(id_aluno, nome, rm) {
    try {
      const { isConfirmed } = await Alert({ tipo: "Alert", mensagem: `Deseja deletar o aluno ${rm}` });
      if (isConfirmed) {
        await api.delete(`/aluno/apagar?id_aluno=${id_aluno}&rm=${rm}`);
        setReload(true);
      }
    } catch (err) {
      console.log(err);
      Alert({ tipo: "Erro2", mensagem: "Ocorreu um erro ao deletar aluno" });
    }
  }

  // function handlePageChange(newPage) {
  //   if (newPage >= 1 && newPage <= totalPages && newPage !== page) {
  //     setPage(newPage);
  //   }
  // }

  return (
    <>
      <ViewPicture viewPicture={viewPicture} setViewPicture={setViewPicture} img={imgAluno} setImgAluno={setImgAluno} />
      <Container>
        <Menus>
          <Title>Controle de Alunos</Title>
          <Buttons>
            <Button
              event={() => {
                Navigate("/secretaria");
              }}
              width="12%"
              margintop="2%"
              placeholder="Voltar"
              backgroundcolor="#1a2e35"
              borderRadius="30px 30px 0px 0px"
            />
            <Button
              event={() => {
                Navigate("/cadastroaluno");
              }}
              width="12%"
              margintop="2%"
              backgroundcolor="#1a2e35"
              placeholder="Adicionar"
              borderRadius="30px 30px 0px 0px"
            />
            <Button
              event={() => {
                handleDownloadXLSX();
              }}
              width="12%"
              margintop="2%"
              backgroundcolor="#1a2e35"
              placeholder="Download"
              borderRadius="30px 30px 0px 0px"
            />
            <Button
              event={() => {
                Navigate("/alunosemfoto");
              }}
              width="14%"
              margintop="2%"
              backgroundcolor="#1a2e35"
              placeholder="Alunos Sem Foto"
              borderRadius="30px 30px 0px 0px"
            />
            <Button
              event={() => {
                setExibirInativos(!exibirInativos);
              }}
              width="12%"
              margintop="2%"
              backgroundcolor="#1a2e35"
              placeholder={TrocaTextoInativos}
              borderRadius="30px 30px 0px 0px"
            />
            {exibirInativos ||
            searchRm.length ||
            searchNome.length ||
            searchDataNascimento.length ||
            searchDataInicio.length ||
            searchDataFim.length ||
            searchCurso.length ||
            searchConvenio.length ? null : (
              <>
                {mostrarTodos < alunos.length ? (
                  <Button
                    event={() => setMostrarTodos(alunos.length)}
                    width="12%"
                    margintop="2%"
                    backgroundcolor="#1a2e35"
                    placeholder="Mostrar Todos"
                    borderRadius="30px 30px 0px 0px"
                  />
                ) : (
                  <Button
                    event={() => setMostrarTodos(alunos.length * limite)}
                    width="12%"
                    margintop="2%"
                    backgroundcolor="#1a2e35"
                    placeholder="Reduzir Alunos"
                    borderRadius="30px 30px 0px 0px"
                  />
                )}
              </>
            )}
          </Buttons>
          {/* <Colletion>
            <CheckBox placeholder="Desativar Todos" marginTop={24} />
          </Colletion> */}
        </Menus>
        <ContainerTable>
          <Table>
            <Theader>
              <tr>
                <ThRm>
                  <Grup>
                    <Pesquisar
                      color="white"
                      placeholder="RM"
                      name="rm"
                      placeholdercolor="white"
                      event={(e) => {
                        setMostrarTodos(e.target.value.length > 2 ? alunos.length * 0.5 : alunos.length * limite);
                        setSearchRm(e.target.value);
                      }}
                    />
                  </Grup>
                </ThRm>
                <Th>
                  <Grup>
                    <Pesquisar
                      placeholder="Nome"
                      name="nome"
                      event={(e) => {
                        setMostrarTodos(e.target.value.length > 2 ? alunos.length * 0.5 : alunos.length * limite);
                        setSearchNome(e.target.value);
                      }}
                    />
                  </Grup>
                </Th>
                <Th>
                  <Grup>
                    <Pesquisar
                      placeholder="Nascimento"
                      name="data_nascimento"
                      event={(e) => {
                        setMostrarTodos(e.target.value.length > 2 ? alunos.length * 0.5 : alunos.length * limite);
                        setSearchDataNascimento(e.target.value);
                      }}
                      onInput={(e) => {
                        let value = e.target.value.replace(/\D/g, ""); // Remove qualquer caractere que não seja número
                        if (value.length > 2) {
                          value = value.slice(0, 2) + "/" + value.slice(2);
                        }
                        if (value.length > 5) {
                          value = value.slice(0, 5) + "/" + value.slice(5);
                        }
                        e.target.value = value; // Atualiza o campo de input com o formato
                      }}
                    />
                  </Grup>
                </Th>
                <Th>
                  <Grup>
                    <Pesquisar
                      placeholder="Data Início"
                      name="data_inicio"
                      event={(e) => {
                        setMostrarTodos(e.target.value.length > 2 ? alunos.length : alunos.length * limite);
                        setSearchDataInicio(e.target.value);
                      }}
                      onInput={(e) => {
                        let value = e.target.value.replace(/\D/g, ""); // Remove qualquer caractere que não seja número
                        if (value.length > 2) {
                          value = value.slice(0, 2) + "/" + value.slice(2);
                        }
                        if (value.length > 5) {
                          value = value.slice(0, 5) + "/" + value.slice(5);
                        }
                        e.target.value = value; // Atualiza o campo de input com o formato
                      }}
                    />
                  </Grup>
                </Th>
                <Th>
                  <Grup>
                    <Pesquisar
                      placeholder="Data Fim"
                      name="data_fim"
                      event={(e) => {
                        setSearchDataFim(e.target.value);
                      }}
                      onInput={(e) => {
                        setMostrarTodos(e.target.value.length > 2 ? alunos.length : alunos.length * limite);
                        let value = e.target.value.replace(/\D/g, ""); // Remove qualquer caractere que não seja número
                        if (value.length > 2) {
                          value = value.slice(0, 2) + "/" + value.slice(2);
                        }
                        if (value.length > 5) {
                          value = value.slice(0, 5) + "/" + value.slice(5);
                        }
                        e.target.value = value; // Atualiza o campo de input com o formato
                      }}
                    />
                  </Grup>
                </Th>
                <Th>
                  <Grup>
                    <Pesquisar
                      placeholder="Curso"
                      name="nome_curso"
                      event={(e) => {
                        setSearchCurso(e.target.value);
                      }}
                    />
                  </Grup>
                </Th>
                <Th>
                  <Grup>
                    <Pesquisar
                      placeholder="Convênio"
                      name="convenio"
                      event={(e) => {
                        setSearchConvenio(e.target.value);
                      }}
                    />
                  </Grup>
                </Th>
                <Th></Th>
                <Th></Th>
                <th>{filteredAlunos.length} Alunos</th>
              </tr>
            </Theader>
            <Tbody>
              {filteredAlunos?.map((a, i) => (
                <Trbody key={i} style={a?.ativo == 0 ? { color: "red" } : {}}>
                  <TdUpload $loading={loadingFotosPorRM[a?.rm]}>
                    {a?.rm}
                    {a?.ativo == 0 ? null : loadingFotosPorRM[a?.rm] ? (
                      <div>
                        <Loading tamanho="5px" />
                      </div>
                    ) : (
                      <PreviewImage
                        onClick={() => takePhoto(fotosAlunos[a?.rm])}
                        src={fotosAlunos[a?.rm] || UserDefault}
                      />
                    )}
                  </TdUpload>
                  <Td>{a?.nome_aluno}</Td>
                  <Td>{format(new Date(a?.dt_nascimento), "dd/MM/yyyy")}</Td>
                  <Td>{format(new Date(a?.dt_inicio), "dd/MM/yyyy")}</Td>
                  <Td>{format(new Date(a?.dt_termino), "dd/MM/yyyy")}</Td>
                  <Td>{a?.nome_curso}</Td>
                  <Td>{a?.convenio}</Td>
                  <Td>
                    <EditButton
                      title="Editar Aluno"
                      onClick={() => {
                        setEditAluno(a);
                        setShow(true);
                      }}
                    />
                  </Td>
                  <Td>
                    <DesativarButton
                      title={a?.ativo == 0 ? "Ativar Aluno" : "Desativar Aluno"}
                      onClick={() => {
                        desativarAluno(a?.rm, a?.id, a?.ativo == 1);
                      }}
                    />
                  </Td>
                  <Td>
                    <DeleteButton
                      title="Deletar Aluno"
                      onClick={() => {
                        deletarAluno(a?.id, a?.nome, a?.rm);
                      }}
                    />
                  </Td>
                </Trbody>
              ))}
            </Tbody>
          </Table>
        </ContainerTable>
        {/* Paginação melhorada */}
        {/* {totalItems > limite && (
          <Menus>
            <Button
              event={() => handlePageChange(page - 1)}
              width="12%"
              placeholder="Anterior"
              backgroundcolor="#1a2e35"
              borderRadius="0px 0px 30px 30px"
              disabled={page <= 1}
            />

            <div
              className="page"
              // style={{
              //   display: "flex",
              //   alignItems: "center",
              //   gap: "1rem",
              //   color: totalPages <= 1 ? "#d0d0d0" : "#333",
              // }}
            >
              <div style={{ color: totalPages <= 1 ? "#d0d0d0" : "", marginLeft: -30 }}>
                Página {page} de {totalPages}
              </div>
            </div>

            <Button
              event={() => handlePageChange(page + 1)}
              width="12%"
              placeholder="Próxima"
              backgroundcolor="#1a2e35"
              borderRadius="0px 0px 30px 30px"
              disabled={page >= totalPages}
            />
          </Menus>
        )} */}

        {/* Navegação rápida de páginas (opcional) */}
        {/* {totalPages > 5 && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "0.5rem",
              marginTop: "1rem",
            }}
          >
            {[...Array(Math.min(5, totalPages))].map((_, index) => {
              let pageNumber;
              if (totalPages <= 5) {
                pageNumber = index + 1;
              } else if (page <= 3) {
                pageNumber = index + 1;
              } else if (page >= totalPages - 2) {
                pageNumber = totalPages - 4 + index;
              } else {
                pageNumber = page - 2 + index;
              }

              return (
                <button
                  key={pageNumber}
                  onClick={() => handlePageChange(pageNumber)}
                  style={{
                    padding: "0.5rem 1rem",
                    backgroundColor: page === pageNumber ? "#1a2e35" : "#f0f0f0",
                    color: page === pageNumber ? "white" : "#333",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "0.9em",
                  }}
                >
                  {pageNumber}
                </button>
              );
            })}
          </div>
        )} */}
        <EditAluno
          Show={Show}
          setShow={setShow}
          setEditAluno={setEditAluno}
          editAluno={editAluno}
          setReload={setReload}
        />
      </Container>
    </>
  );
}
